import { experienceQueryKeys as e } from "./useExperienceQueryKeys.mjs";
import { useMutation as t, useQueryClient as n } from "@maat/store-hooks";
import { experiencesApi as r } from "@maat/api-main";
//#region src/experiences/useArchiveExperienceMutation.ts
var i = () => {
	let i = n();
	return t({
		mutationFn: (e) => r.archiveExperience(e),
		onSuccess: (t, n) => {
			i.invalidateQueries({ queryKey: e.list() }), i.invalidateQueries({ queryKey: e.detail(n) });
		}
	});
};
//#endregion
export { i as useArchiveExperienceMutation };
